<template>
  <div
    v-if="values.length"
    class="row audit-info"
  >
    <div
      v-for="(val, index) in values"
      :key="index"
      :class="`col-${val.cols}`"
    >
      <div class="font-weight-bold">
        {{ val.header }}
      </div>

      <span v-if="val.value !== null && val.value !== undefined && val.header === 'MIFID II'">
        <icon
          :icon="val.value ? 'tick-badge' : 'cross-badge'"
          :class="{negative: !val.value, positive: val.value }"
        />
      </span>

      <span
        v-else-if="val.value !== null && val.value !== undefined"
        :class="val.classes"
      >
        <router-link
          v-if="val.link"
          :to="val.link"
        >
          {{ val.value }}
        </router-link>

        <a
          v-else-if="val.externalLink"
          :href="`${ val.email ? 'mailto:' : ''}${val.value}`"
          target="_blank"
        >
          {{ val.value }}
        </a>

        <span v-else>
          {{ val.value }}
        </span>
      </span>

      <span v-else>
        -
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audit: {
      type: Object,
      default: () => ({}),
    },
    morph: {
      type: String,
      required: true,
    },
    displayAccount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    values () {
      if (this.audit.sendgrid && this.audit.sendgrid.notification_id && this.audit.sendgrid.event === 'click') {
        return [
          {header: 'URL', value: this.audit.sendgrid.url, cols: 12},
          {header: 'View Email', externalLink: true, cols: 12, value: `${process.env.VUE_APP_GATEWAY_ENDPOINT}alerts/notifications/view-in-browser/${this.audit.sendgrid.notification_id}`},
        ]
      }
      if (this.audit.sendgrid && this.audit.sendgrid.response) {
        return [
          {header: 'Email', value: this.audit.sendgrid.email, cols: 3},
          {header: 'Server Response', value: this.audit.sendgrid.response, cols: 9, classes: 'code'},
        ]
      } else if (this.audit.sendgrid && this.audit.sendgrid.reason) {
        return [
          {header: 'Email', value: this.audit.sendgrid.email, cols: 3},
          {header: 'Server Response', value: this.audit.sendgrid.reason, cols: 9, classes: 'code'},
        ]
      }


      switch (this.type) {
        case 'Account':
          return [
            {header: 'MIFID II', value: this.what.is_mifid, cols: 4},
            {header: 'Account Type', value: this.getAttr('account_type'), cols: 4},
            {header: 'Website', value: this.what.website, cols: 4, externalLink: true},
          ]

        case 'User':
          return [
            {header: 'Job Title', value: this.what.job_title, cols: 3},
            {header: 'Email', value: this.what.email, cols: 4, externalLink: true, email: true},
            {header: 'Package(s)', value: this.getPackages, cols: 3},
            {header: 'Phone', value: this.what.phone, cols: 2},
          ]

          // if (!this.displayAccount) {
          //   result.push({header: 'Account', value: this.getAccount, cols: 3, link:
          //     (this.getAccount
          //     ? {
          //       name: 'accounts.view',
          //       params: {
          //         accountId: this.what.account_id,
          //       },
          //     }
          //     : false),
          //   })
          // }

        case 'Article':
          return [
            {header: 'Analyst', value: this.getAnalyst, cols: 5},
            {header: 'Channel', value: this.getChannel, cols: 5},
            {header: 'Article Pages', value: this.what.page_count, cols: 2},
          ]

        case 'Alert':
          return [
            {header: 'From Name', value: this.what.from_name, cols: 4, externalLink: true, email: true},
            {header: 'From Email', value: this.what.from_email, cols: 4, externalLink: true, email: true},
            {header: 'To Email', value: this.audit.sendgrid.email, cols: 4, externalLink: true, email: true},
          ]

      }

      if (this.audit && this.audit.action && this.audit.action) {
        switch (this.audit.action.action) {
          case 'Followed':
          case 'Unfollowed':
          case 'Updated follow':
            return [
              {header: 'Who', value: this.audit.relation.name, cols: 4},
              {header: 'Triggered by', value: this.audit.who.name, cols: 4},
            ]
        }
      }


      if (this.audit.sendgrid && this.audit.sendgrid.notification_id) {
        return [
          {header: 'View Email', value: `${process.env.VUE_APP_GATEWAY_ENDPOINT}alerts/notifications/view-in-browser/${this.audit.sendgrid.notification_id}`, cols: 12, externalLink: true},
        ]
      }

      return []
    },
    what () {
      if (!this.audit) {
        return {}
      }
      return this.audit[this.morph] || {}
    },

    type () {
      if (!this.audit || !this.what) {
        return null
      }

      const type = this.audit[this.morph + '_type']

      return type ? type.substr(type.lastIndexOf('\\') + 1) : 'User'
    },

    getAnalyst () {
      return this.what.analysts && this.what.analysts.length > 0 && this.what.analysts[0].name
        ? this.what.analysts[0].name
        : null
    },

    getChannel () {
      return this.what.channel_content_type && this.what.channel_content_type.channel && this.what.channel_content_type.channel.name
        ? this.what.channel_content_type.channel.name
        : null
    },

    getAccount () {
      return this.audit.account && this.audit.account.name
        ? this.audit.account.name
        : null
    },

    getPackages () {
      return this.what.subscriptions && this.what.subscriptions.length > 0
        ? this.what.subscriptions.filter((s) => s.role).map((s) => s.role.name).join(', ')
        : null
    },
  },
  methods: {
    getAttr (attr) {
      return this.what[attr] && this.what[attr].name
        ? this.what[attr].name
        : null
    },
  },
}
</script>
